import { render, staticRenderFns } from "./EditorCard.vue?vue&type=template&id=346c906a&scoped=true"
import script from "./EditorCard.vue?vue&type=script&lang=js"
export * from "./EditorCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346c906a",
  null
  
)

export default component.exports